import {Form} from 'react-bootstrap';
import {ControlledInput, RadioCheckInput} from '../../interfaces/Forms';
import CustomTooltip from '../../../Components/CustomTooltip';

interface CheckboxGroupControlledProps {
  options: RadioCheckInput<string>[];
  values: string[];
}

const CheckboxGroupControlled = ({
  name,
  label,
  options,
  values,
  onChange,
  onBlur,
  onReset,
  touched,
  errors,
  required = true,
}: ControlledInput & CheckboxGroupControlledProps): JSX.Element => {
  return (
    <>
      <Form.Label className={`fw-bold fs-3${required ? ' required' : ''}`}>{label}</Form.Label>
      <Form.Group>
        {options.map(({label, value, disabled, description}, index) => {
          return (
            <div className="d-flex align-items-center mb-2" key={index}>
              <Form.Check
                id={name + '_' + value}
                name={name}
                type="checkbox"
                label={
                  <span style={{color: '#686868', fontSize: '1.15rem', fontWeight: 500}}>{label}</span>
                }
                value={value}
                checked={values.includes(value)}
                disabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
                onReset={onReset}
              />
              {description && (
                <CustomTooltip label={description}>
                  <i className="bi bi-info-circle ms-2 text-muted" style={{cursor: 'pointer'}} />
                </CustomTooltip>
              )}
            </div>
          );
        })}
        {touched && errors && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{errors}</span>
            </div>
          </div>
        )}
      </Form.Group>
    </>
  );
};

export default CheckboxGroupControlled;
